<template>
  <SmsMessageForm
    v-if="create"
    :contact-request="contactRequest"
    @cancel="onCancel"
    @created="onCreated"
  />
  <BaseButton v-else primary small @click="create = true"> New Message </BaseButton>
</template>

<script>
import SmsMessageForm from './SmsMessageForm.vue';

export default {
  components: {
    SmsMessageForm,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      create: false,
    };
  },
  methods: {
    onCancel() {
      this.create = false;
    },
    onCreated() {
      this.create = false;
      this.$emit('created');
    },
  },
};
</script>
